const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  }
  catch(e){
    return false;
  }
}

const customLinkPlugin = {
  name: 'customLink',
  display: 'dialog',

  add: function (core) {
    core.addModule([window.SUNEDITOR_MODULES.dialog]);
    const context = core.context;

    context.customLink = {
      modal: null,
      focusElement: null,
      linkText: null,
      newWindow: null,
      downloadCheck: null,
      bookmarkBtn: null,
      _linkAnchor: null,
      linkController: null,
      previewElement: null,
      previewIconDownload: null,
      previewIconBookmark: null,
    };

    // Crear el diálogo
    const linkDialog = this.setDialog(core);
    context.customLink.modal = linkDialog;
    context.customLink.focusElement = linkDialog.querySelector('._se_link_url');
    context.customLink.linkText = linkDialog.querySelector('._se_link_text');
    context.customLink.newWindow = linkDialog.querySelector('._se_link_new_window');
    context.customLink.downloadCheck = linkDialog.querySelector('._se_link_download');
    context.customLink.previewElement = linkDialog.querySelector('._se_link_preview');
    context.customLink.bookmarkBtn = linkDialog.querySelector('._se_bookmark_button');
    context.customLink.previewIconDownload = linkDialog.querySelector('._se_anchor_download_icon');
    context.customLink.previewIconBookmark = linkDialog.querySelector('._se_anchor_bookmark_icon');

    // Agregar evento de preview
    context.customLink.focusElement.addEventListener('input', (e) => {
      const value = e.target.value.trim();
      if (value.length === 0) {
        context.customLink.previewIconBookmark.style.display = 'none';
        context.customLink.bookmarkBtn.classList.remove('active');
      } else {
        if (value.startsWith('#')) {
          context.customLink.previewIconDownload.style.display = 'none';
          context.customLink.previewIconBookmark.style.display = 'block';

          if (!context.customLink.bookmarkBtn.classList.contains('active')) {
            context.customLink.bookmarkBtn.classList.add('active');
          }
        } else {
          context.customLink.previewIconBookmark.style.display = 'none';
          context.customLink.bookmarkBtn.classList.remove('active');
        }
      }

      this.setInputValue(core);
      this.setPreviewValue(core);
    });

    context.customLink.downloadCheck.addEventListener('change', (e) => {
      const checked = e.target.checked;
      if (checked) {
        context.customLink.bookmarkBtn.classList.remove('active');
        context.customLink.previewIconDownload.style.display = 'block';
        context.customLink.previewIconBookmark.style.display = 'none';
      } else {
        context.customLink.previewIconDownload.style.display = 'none';
      }

      this.setInputValue(core);
      this.setPreviewValue(core);
    });

    context.customLink.bookmarkBtn.addEventListener('click', (e) => {
      if (context.customLink.bookmarkBtn.classList.contains('active')) {
        context.customLink.bookmarkBtn.classList.remove('active');
        context.customLink.previewIconBookmark.style.display = 'none';
      } else {
        context.customLink.bookmarkBtn.classList.add('active');
        context.customLink.downloadCheck.checked = false;
        context.customLink.previewIconDownload.style.display = 'none';
        context.customLink.previewIconBookmark.style.display = 'block';
      }

      this.setInputValue(core);
      this.setPreviewValue(core);
    });

    // Crear el controlador (cuando haces clic sobre un enlace existente)
    const controller = this.setController(core);
    context.customLink.linkController = controller;

    // Registrar eventos
    linkDialog.querySelector('form').addEventListener('submit', this.submit.bind(core));
    controller.addEventListener('click', this.onClickController.bind(core));

    // Insertar en el editor
    context.dialog.modal.appendChild(linkDialog);
    context.element.relative.appendChild(controller);
  },

  setInputValue: function (core) {
    const context = core.context;

    if (context.customLink.bookmarkBtn.classList.contains('active')) {
      if (!context.customLink.focusElement.value.startsWith('#')) {
        context.customLink.focusElement.value = `#${context.customLink.focusElement.value ?? ''}`;
      }
    } else {
      if (context.customLink.focusElement.value.startsWith('#')) {
        context.customLink.focusElement.value = context.customLink.focusElement.value.replace('#', '')
      }
    }
  },

  setPreviewValue: function (core) {
    const context = core.context;

    if (context.customLink.bookmarkBtn.classList.contains('active')) {
      context.customLink.previewElement.textContent = context.customLink.focusElement.value;
    } else {
      if (context.customLink.focusElement.value.length === 0) {
        context.customLink.previewElement.textContent = '';
      } else if (
        !isValidUrl(context.customLink.focusElement.value) &&
        !context.customLink.downloadCheck?.checked &&
        !context.customLink.focusElement.value.startsWith('/')
      ) {
        context.customLink.previewElement.textContent = `/${context.customLink.focusElement.value}`;
      } else {
        context.customLink.previewElement.textContent = context.customLink.focusElement.value;
      }
    }
  },

  setDialog: function (core) {
    const lang = core.lang;
    const dialog = core.util.createElement('DIV');
    dialog.className = 'se-dialog-content';
    dialog.style.display = 'none';

    dialog.innerHTML = `
      <form class="editor_link">
        <div class="se-dialog-header">
          <button type="button" data-command="close" class="se-btn se-dialog-close" title="${lang.dialogBox.close}">
            ${core.icons.cancel}
          </button>
          <span class="se-modal-title">${lang.dialogBox.linkBox.title}</span>
        </div>
        <div class="se-dialog-body">
          <div class="se-dialog-form">
            <label>${lang.dialogBox.linkBox.url}</label>
            <div class="se-dialog-form-files">
              <input class="se-input-form _se_link_url" type="text" />
              <button type="button" class="se-btn se-dialog-files-edge-button _se_bookmark_button" title="${lang.dialogBox.linkBox.bookmark}" style="display: none">
                ${core.icons.bookmark}
              </button>
            </div>
            <div class="se-anchor-preview-form">
              <span class="se-svg se-anchor-preview-icon _se_anchor_download_icon" style="display:none">
                ${core.icons.download}
              </span>
              <span class="se-svg se-anchor-preview-icon _se_anchor_bookmark_icon" style="display:none">
                ${core.icons.bookmark}
              </span>
              <pre class="se-link-preview _se_link_preview"></pre>
            </div>
          </div>
          <div class="se-dialog-form">
            <label>${lang.dialogBox.linkBox.text}</label>
            <input class="se-input-form _se_link_text" type="text" />
          </div>
          <div class="se-dialog-form se-dialog-form-footer">
            <label><input type="checkbox" class="_se_link_new_window" /> ${lang.dialogBox.linkBox.newWindowCheck}</label>
            <label><input type="checkbox" class="_se_link_download" /> ${lang.dialogBox.linkBox.downloadLinkCheck}</label>
          </div>
        </div>
        <div class="se-dialog-footer">
          <button type="submit" class="se-btn-primary"><span>${lang.dialogBox.submitButton}</span></button>
        </div>
      </form>
    `;

    return dialog;
  },

  setController: function (core) {
    const lang = core.lang;
    const icons = core.icons;
    const div = core.util.createElement('DIV');
    div.className = 'se-controller se-controller-link';
    div.innerHTML = `
      <div class="se-arrow se-arrow-up"></div>
      <div class="link-content">
        <span><a target="_blank" href=""></a>&nbsp;</span>
        <div class="se-btn-group">
          <button type="button" data-command="update" class="se-tooltip">
            ${icons.edit}
            <span class="se-tooltip-inner"><span class="se-tooltip-text">${lang.controller.edit}</span></span>
          </button>
          <button type="button" data-command="unlink" class="se-tooltip">
            ${icons.unlink}
            <span class="se-tooltip-inner"><span class="se-tooltip-text">${lang.controller.unlink}</span></span>
          </button>
          <button type="button" data-command="delete" class="se-tooltip">
            ${icons.delete}
            <span class="se-tooltip-inner"><span class="se-tooltip-text">${lang.controller.remove}</span></span>
          </button>
        </div>
      </div>
    `;
    return div;
  },

  open: function () {
    this.plugins.dialog.open.call(this, 'customLink', 'customLink' === this.currentControllerName);
  },

  submit: function (e) {
    e.preventDefault();
    e.stopPropagation();

    this.showLoading();

    const context = this.context.customLink;
    const urlInput = context.focusElement.value.trim();
    const textInput = context.linkText.value.trim();
    const newWindow = context.newWindow.checked;
    const download = context.downloadCheck.checked;

    try {
      if (urlInput) {
        const text = textInput || urlInput;
        if (!this.context.dialog.updateModal) {
        const a = this.util.createElement('A');
        a.href = urlInput;
        a.textContent = text;
        if (newWindow) a.target = '_blank';
        if (download) a.setAttribute('download', '');

        this.insertNode(a);
        this.setRange(a, 0, a, 1);
      } else {
        const existing = context._linkAnchor;
        existing.href = urlInput;
        existing.textContent = text;
        if (newWindow) existing.target = '_blank';
        else existing.removeAttribute('target');
        if (download) existing.setAttribute('download', '');
        else existing.removeAttribute('download');
      }

      this.history.push(false);
      }
    } finally {
      this.plugins.dialog.close.call(this);
      this.closeLoading();
      this.focus();
    }
  },

  active: function (element) {
    if (!element) {
      if (this.controllerArray.indexOf(this.context.customLink.linkController) > -1) {
        this.controllersOff();
      }
    } else if (this.util.isAnchor(element)) {
      if (this.controllerArray.indexOf(this.context.customLink.linkController) < 0) {
        this.plugins.customLink.call_controller.call(this, element);
      }
      return true;
    }
    return false;
  },

  on: function (update) {
    const contextCustomLink = this.context.customLink;

    if (!update) {
      contextCustomLink._linkAnchor = null;
      contextCustomLink.focusElement.value = '';
      contextCustomLink.linkText.value = '';
      contextCustomLink.previewElement.textContent = '';
      contextCustomLink.newWindow.checked = false;
      contextCustomLink.downloadCheck.checked = false;
      contextCustomLink.previewIconDownload.style.display = 'none';
      contextCustomLink.previewIconBookmark.style.display = 'none';
      contextCustomLink.bookmarkBtn.classList.remove('active');
    } else if (contextCustomLink._linkAnchor) {
      const a = contextCustomLink._linkAnchor;
      contextCustomLink.focusElement.value = a.getAttribute('href') || '';
      contextCustomLink.linkText.value = a.textContent;
      contextCustomLink.newWindow.checked = a.getAttribute('target') === '_blank';
      contextCustomLink.downloadCheck.checked = a.hasAttribute('download');
      contextCustomLink.previewIconDownload.style.display = contextCustomLink.downloadCheck.checked ? 'block' : 'none';
      contextCustomLink.previewIconBookmark.style.display = contextCustomLink.focusElement.value.startsWith('#');
      this.plugins.customLink.setPreviewValue(this);
    }
  },

  call_controller: function (aTag) {
    this.context.customLink._linkAnchor = aTag;
    const controller = this.context.customLink.linkController;
    const link = controller.querySelector('a');
    link.href = aTag.getAttribute('href');
    link.textContent = aTag.textContent;

    const offset = this.util.getOffset(aTag, this.context.element.wysiwygFrame);
    controller.style.top = `${offset.top + aTag.offsetHeight + 10}px`;
    controller.style.left = `${offset.left - this.context.element.wysiwygFrame.scrollLeft}px`;
    controller.style.display = 'block';

    this.controllersOn(controller, aTag, 'customLink');
  },

  onClickController: function (e) {
    e.stopPropagation();
    const command = e.target.getAttribute('data-command');
    if (!command) return;
    e.preventDefault();

    const ctx = this.context.customLink;
    if (/update/.test(command)) {
      this.plugins.dialog.open.call(this, 'customLink', true);
    } else if (/unlink/.test(command)) {
      const sc = this.util.getChildElement(ctx._linkAnchor, n => n.nodeType === 3, false);
      const ec = this.util.getChildElement(ctx._linkAnchor, n => n.nodeType === 3, true);
      this.setRange(sc, 0, ec, ec.textContent.length);
      this.nodeChange(null, null, ['A'], false);
    } else {
      this.util.removeItem(ctx._linkAnchor);
      ctx._linkAnchor = null;
      this.focus();
      this.history.push(false);
    }
    this.controllersOff();
  },
};

export default customLinkPlugin;
